import {handleFetchError, HtmlDialog} from "../../helpers/functions.js";
import JSX from "../../helpers/react.js";
import {ServerApi} from "../../api.js";
import {Role} from "../../../../../nodeserver/structs/database";
import {userPermissions} from "../../config.js";
import {Select} from "../elements/Select.js";
import RefObject = JSX.RefObject;

export function EditGroupDialog({currentRoles, OnSuccess}: {currentRoles: Role[], OnSuccess: (data: Role[])=>any}){
    let values: Role[] = currentRoles;
    const select: RefObject<HTMLSelectElement> = {};
    const ans = (
        <HtmlDialog className="edit-roles" OnClose={()=>{}}>
            <div className="top-data">
                <h1>Редактирование ролей</h1>
                <div className="content" style={{display:"block"}}>
                    <Select name="groups" multiple={true} placeholder="Роли" onChange={(...change)=>{values = change.map(e=>e.value) as Role[]}} ref={select}>
                        {
                            ...Object.entries(userPermissions).map(([id, description])=>(
                                {
                                    selected: currentRoles.includes(id as Role),
                                    name: description,
                                    value: id
                                }
                            ))
                        }
                    </Select>
                </div>
            </div>
            <div className="bottom-buttons">
                <div className="cancel-button main-button neutral bordered">Отмена</div>
                <div className="save-button main-button bordered" onClick={()=>
                    updateGroups(page_id!, values)
                        .then(()=>(ans.close(), OnSuccess(values)))
                        .catch(handleFetchError)
                }>Сохранить</div>
            </div>
        </HtmlDialog>
    );
    setTimeout(()=>$(select.value!).slimSelect());
    return ans;
}

async function updateGroups(userId: number, groups: Role[]){
    await ServerApi.users.update(userId, {roles: groups})
}

